(function() {
	"use strict"

	angular.module( "ATMGurus" )

	/**
	*
	*	Generic enough Pagination handler
	*
	*
	*/

	.directive( "pagination", [
		function() {
			return {
				restrict: "A",
				template: require("../../templates/bits/pagination.html"),
				// templateUrl:  "/templates/bits/pagination.html",
				scope: {
					descriptor: '=pagination',
					filters: '='
				},
				link: function(  scope, element, attrs, ctrl ) {

					if ( !scope.descriptor ) {
						return
					}

					scope.gotoPage = function( page ) {
						scope.filters.page = page;
					}

					scope.$watch( 'descriptor', function( nv, ov ) {
						init();
					}, true )

					function init() {

						// Final object
						scope.pagination = {
							first: false,
							first_ellipse: false,
							current: undefined,
							prev: undefined,
							next: undefined,
							last_ellipse: false,
							last: false,
							pages: undefined
						}

						// we need intergers
						// scope.descriptor.first_page = parseInt( scope.descriptor.first_page )
						scope.descriptor.current_page = parseInt( scope.descriptor.current_page )
						scope.descriptor.last_page = parseInt( scope.descriptor.last_page )

						scope.pagination.current = scope.descriptor.current_page;

						if ( scope.descriptor.last_page === 1 ) {
							scope.pagination.current = 1;
							return;
						}
						else {

							// is last page current or visible
							if ( scope.descriptor.last_page !== scope.pagination.current && scope.descriptor.last_page !== 1) {
								scope.pagination.last =  scope.descriptor.last_page;
								scope.descriptor.next_page = true;
							}
							else {
								scope.descriptor.next_page = false;
								scope.pagination.last = false;
							}

							// first page current or visible?
							if ( scope.pagination.current > 1  ) {
								scope.descriptor.prev_page = true;
								scope.pagination.first = true;
							}
							else {
								scope.descriptor.prev_page = false;
							}

							// first ellipse
							if ( scope.pagination.current > 3 ) {
								scope.pagination.first_ellipse = "...";
							}

							// last ellipse
							if ( scope.pagination.current + 1 < scope.descriptor.last_page - 1 ) {
								scope.pagination.last_ellipse = "...";
							}

							// prev
							if ( scope.pagination.current > 2 ) {
								scope.pagination.prev = scope.pagination.current - 1;
							}

							// next
							if ( scope.pagination.current < ( scope.descriptor.last_page - 1 ) ) {
								scope.pagination.next = scope.pagination.current + 1;
							}

						}

					}
				}
			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/directives/pagination.js